module.exports = __webpack_public_path__ + "img/addressbook_fill.8532a2a7.png";